// import { useRuntimeConfig } from "#imports";

export const GATEWAY_PREFIX_COMMON = import.meta.env.VITE_GATEWAY_PREFIX_COMMON;
export const GATEWAY_PREFIX_FORUM = import.meta.env.VITE_GATEWAY_PREFIX_FORUM;
export const IS_HETAO_OJ = import.meta.env.VITE_HETAO_OJ === '1';
export const IS_SAAS_OJ = import.meta.env.VITE_SAAS_OJ === '1';

// 通过 nuxt 插件初始化这些数据
export function initRuntimeConfig() {
  // const config = useRuntimeConfig();
  // GATEWAY_PREFIX_COMMON = config.public.GATEWAY_PREFIX_COMMON as string;
  // GATEWAY_PREFIX_FORUM = config.public.GATEWAY_PREFIX_FORUM as string;
  // IS_HETAO_OJ = config.public.IS_HETAO_OJ as boolean;
  // IS_SAAS_OJ = config.public.IS_SAAS_OJ as boolean;

  // 目前使用到的常量都是构建时确定的常量，并不需要在运行时进行修改，所以直接使用环境变量即可。
  // 如果后续需要使用运行时变量，那么可以继续使用useRuntimeConfig
}

export function getZoneBase(zone?: string) {
  return IS_HETAO_OJ && zone ? `/${zone}` : '';
}
